import {Figure} from "../Figure";
import {DebtTypes} from "../../../../../../../../models";

export function revolvingCredit(mortgage) {
    // App1 Credit Card Limits
    // App 1 Overdraft Limits
    // App 1 Credit + Overdraft = creditFacilityLimits
    // App1 Credit Utilisation
    // App1 Overdraft Utilisation
    // App 1 Credit + Overdraft = highestCreditUtilisation
    // App 1 Credit Card Balance

    function creditsLimits({applicant}) {
        const uploadSections = mortgage.uploadSections.filter(it => [DebtTypes.CREDITCARD,DebtTypes.STORECARD].includes(it.data?.debtType) && it.applicant === applicant);

        const app = applicant === 1 ? mortgage.applicant1 : mortgage.applicant2
        const debtFilter = d => [DebtTypes.CREDITCARD, DebtTypes.STORECARD].includes(d.debtType) && !d.isClosed
        const accountFilter = a => a.hasOverdraft && !a.isClosed
        const allCards = app.debts.filter(debtFilter)
        const allOverdrafts = app.accounts.filter(accountFilter)

        const creditCardLimitsFigure = new Figure({
            label: `${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}'s Credit Card Limits`,
            disabled: !allCards.length,
            namesPath: [`applicant${applicant}`, 'credit', 'creditCardLimits'],
            provable: true,
            float: false,
            source: null,
        })
        const overdraftLimitsFigure = new Figure({
            label: `${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}'s Overdraft Limits`,
            disabled: !allOverdrafts.length,
            namesPath: [`applicant${applicant}`, 'credit', 'overdraftLimits'],
            provable: true,
            float: false,
            source: null,
        })
        const maxCardUtilisationFigure = new Figure({
            label: `${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}'s Max Credit Card Utilisation`,
            disabled: !allCards.length,
            namesPath: [`applicant${applicant}`, 'credit', 'maxCardUtilisation'],
            provable: true,
            float: false,
            source: null,
        })
        const lastCardBalanceFigure = new Figure({
            label: `${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}'s Last Credit Card Balance`,
            disabled: !allCards.length,
            namesPath: [`applicant${applicant}`, 'credit', 'lastCardBalance'],
            provable: true,
            float: false,
            source: null,
        })
        const maxOverdraftUtilisationFigure = new Figure({
            label: `${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}'s Max Overdraft Utilisation`,
            disabled: !allOverdrafts.length,
            namesPath: [`applicant${applicant}`, 'credit', 'maxOverdraftUtilisation'],
            provable: true,
            float: false,
            source: null,
        })
        const creditLimitFigure = new Figure({
            label: `${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}'s Credit Limits`,
            disabled: !allCards.length && !allOverdrafts.length,
            namesPath: [`applicant${applicant}`, 'creditFacilityLimits'],
            provable: true,
            float: false,
            source: null,
        })
        const highestUtilisationFigure = new Figure({
            label: `${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}'s Highest Credit Utilisation`,
            disabled: !allCards.length && !allOverdrafts.length,
            namesPath: [`applicant${applicant}`, 'highestCreditUtilisation'],
            provable: true,
            float: false,
            source: null,
        })
        let cardLimitsTot = 0
        let overdraftLimitsTot = 0
        let maxCardUtilisationTot = 0
        let maxOverdraftUtilisationTot = 0
        let cardBalanceTot = 0
        let creditLimitTot = 0
        let highestUtilisationTot = 0

        allCards.forEach((debt, i) => {
            // old
            // highestUtilisationTot += debt.highestCreditUtilisation || 0
            // creditLimitTot += debt.creditLimit || 0
            const name = applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName

            // creditLimitFigure.addMethod({
            //     description: `${name}'s ${debt.lender} Card`,
            //     claimed: debt.creditLimit || 0,
            //     amount: debt.creditLimit || 0,
            //     operator: '+',
            // })
            // highestUtilisationFigure.addMethod({
            //     description: `${name}'s ${debt.lender} Card Highest Utilisation`,
            //     claimed: debt.highestCreditUtilisation || 0,
            //     amount: debt.highestCreditUtilisation || 0,
            //     operator: '+',
            // })

            //new
            maxCardUtilisationTot += debt.highestCreditUtilisation || 0
            cardLimitsTot += debt.creditLimit || 0
            creditCardLimitsFigure.addMethod({
                description: `${name}'s ${debt.lender} Card`,
                claimed: debt.creditLimit || 0,
                amount: debt.creditLimit || 0,
                operator: '+'
            })
            maxCardUtilisationFigure.addMethod({
                description: `${name}'s ${debt.lender} Card`,
                claimed: debt.highestCreditUtilisation || 0,
                amount: debt.highestCreditUtilisation || 0,
                operator: '+'
            })
            const ccUploads = uploadSections.find(it => it.index === debt.id)?.activeUploads.filter(it => it.isVerifiable && it.values?.documentDate)
            const latestUpload = ccUploads?.length ? ccUploads.sort((a,b)=>{
                // sort by documentDate (already dayjs) descending
                return b.values.documentDate.diff(a.values.documentDate)
            })[0] : null
            console.log({ccUploads,latestUpload})
            if (latestUpload) {
                cardBalanceTot += latestUpload?.values?.outstandingBalance || 0
            }
            lastCardBalanceFigure.addMethod({
                description: `${name}'s ${debt.lender} Card Last Balance`,
                claimed: debt.outstanding || 0,
                amount: latestUpload?.values?.outstandingBalance || 0,
                operator: '+'
            })
        })
        allOverdrafts.forEach((account, i) => {
            const name = applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName
            //old
            // creditLimitTot += account.overdraftLimit || 0
            // highestUtilisationTot += account.highestCreditUtilisation || 0

            // creditLimitFigure.addMethod({
            //     description: `${name}'s ${account.institution} Overdraft`,
            //     claimed: account.overdraftLimit || 0,
            //     amount: account.overdraftLimit || 0,
            //     operator: '+',
            // })
            // highestUtilisationFigure.addMethod({
            //     description: `${name}'s ${account.institution} Overdraft Highest Utilisation`,
            //     claimed: account.highestCreditUtilisation || 0,
            //     amount: account.highestCreditUtilisation || 0,
            //     operator: '+',
            // })

            //new
            maxOverdraftUtilisationTot += account.highestCreditUtilisation || 0
            overdraftLimitsTot += account.overdraftLimit || 0
            overdraftLimitsFigure.addMethod({
                description: `${name}'s ${account.institution} Overdraft`,
                claimed: account.overdraftLimit || 0,
                amount: account.overdraftLimit || 0,
                operator: '+',
            })
            maxOverdraftUtilisationFigure.addMethod({
                description: `${name}'s ${account.institution} Overdraft Max Utilisation`,
                claimed: account.highestCreditUtilisation || 0,
                amount: account.highestCreditUtilisation || 0,
                operator: '+',
            })
        })

        //old
        // creditLimitFigure.setValue(creditLimitTot, `Total Credit Limits for ${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}`)
        // highestUtilisationFigure.setValue(highestUtilisationTot, `Total Highest Credit Utilisation for ${applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName}`)

        //new
        creditCardLimitsFigure.setValue(cardLimitsTot, `Total Credit Card Limits`)
        overdraftLimitsFigure.setValue(overdraftLimitsTot, `Total Overdraft Limits`)
        maxCardUtilisationFigure.setValue(maxCardUtilisationTot, `Total Max Card Utilisation`)
        maxOverdraftUtilisationFigure.setValue(maxOverdraftUtilisationTot, `Total Max Overdraft Utilisation`)
        lastCardBalanceFigure.setValue(cardBalanceTot, 'Total Card Balances')
        return [creditCardLimitsFigure, maxCardUtilisationFigure, overdraftLimitsFigure, maxOverdraftUtilisationFigure, lastCardBalanceFigure]
        return [creditLimitFigure, highestUtilisationFigure, creditCardLimitsFigure, maxCardUtilisationFigure, overdraftLimitsFigure, maxOverdraftUtilisationFigure]
    }

    const list = [...creditsLimits({applicant: 1})]
    if (mortgage.twoApplicants) {
        list.push(...creditsLimits({applicant: 2}))
    }
    return list
    // function creditCards(){
    //     const allCards = []
    //
    //     const fig = new Figure({
    //         label: 'Credit Limits',
    //         disabled: !allCards.length,
    //         namesPath: ['funds', 'gifts'],
    //         provable: true,
    //         float: false,
    //         source: null,
    //     })
    //     let tot = 0
    //     allCards.forEach((debt, i) => {
    //         tot += debt.creditLimit || 0
    //         const name = debt.applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName
    //         fig.addMethod({
    //             description: `${name}'s ${debt.lender}Card`,
    //             claimed: debt.creditLimit ||0,
    //             amount: debt.creditLimit || 0,
    //             operator: '+',
    //         })
    //     })
    //     fig.setValue( tot, 'Total Credit Limits from Cards')
    //     return fig
    // }
    // function overdrafts(){
    //     const allOverdrafts = []
    //     const accountFilter = a=>a.hasOverdraft && !a.isClosed
    //     mortgage.applicant1.accounts.filter(accountFilter).forEach((account) => {
    //         allOverdrafts.push({applicant: 1, ...account})
    //     })
    //     if (mortgage.twoApplicants) {
    //         mortgage.applicant2.accounts.filter(accountFilter).forEach((account) => {
    //             allOverdrafts.push({applicant: 2, ...account})
    //         })
    //     }
    //     const fig = new Figure({
    //         label: 'Overdraft Limits',
    //         disabled: !allOverdrafts.length,
    //         namesPath: ['funds', 'gifts'],
    //         provable: false,
    //         float: true,
    //         source: null,
    //     })
    //     let tot = 0
    //     allOverdrafts.forEach((account, i) => {
    //         tot += account.overdraftLimit || 0
    //         const name = account.applicant === 1 ? mortgage.applicant1.firstName : mortgage.applicant2.firstName
    //         fig.addMethod({
    //             description: `${name}'s ${account.institution} Overdraft`,
    //             claimed: account.overdraftLimit ||0,
    //             amount: account.overdraftLimit || 0,
    //             operator: '+',
    //         })
    //     })
    //     fig.setValue( tot, 'Total Overdraft Limits')
    //     return fig
    // }

}

